export default {
  "about.title": "关于我们",
  "about.subtitle": "致力于为草榴社区用户提供最新、最全的入口指南",

  "about.intro.title": "品牌介绍",
  "about.intro.paragraph1": "草榴二维码指南成立于2020年，是国内最早专注于草榴社区入口信息整理的平台之一。我们致力于为用户提供最新、最稳定、最安全的草榴社区访问入口，帮助广大用户解决因地址变动带来的访问困扰。",
  "about.intro.paragraph2": "我们的团队由资深互联网技术爱好者和内容创作者组成，持续关注草榴社区动态，第一时间更新入口信息。凭借多年的运营经验，我们已帮助数百万用户顺利访问草榴社区。",
  "about.intro.paragraph3": "我们深知用户在寻找可用入口时的焦虑与不便，因此我们始终坚持免费、及时、准确的原则，用心维护本平台的每一处信息。",

  "about.reputation.title": "信誉展示",
  "about.reputation.users": "累计服务用户",
  "about.reputation.updates": "入口更新次数",
  "about.reputation.years": "运营年限",
  "about.reputation.satisfaction": "用户满意度",
  "about.reputation.userFeedback": "用户评价",
  "about.reputation.feedback1": "这个网站帮了我大忙！每次找不到入口就来这里，更新很及时，强烈推荐。",
  "about.reputation.feedback1User": "老用户张先生",
  "about.reputation.feedback2": "教程非常详细，小白也能轻松上手，收藏了。",
  "about.reputation.feedback2User": "新手小李",
  "about.reputation.feedback3": "安全指南写得很好，让我意识到了很多之前忽略的问题。",
  "about.reputation.feedback3User": "资深用户王女士",

  "about.contact.title": "联系我们",
  "about.contact.subtitle": "如有任何问题或建议，欢迎通过以下方式联系我们",
  "about.contact.email": "电子邮箱",
  "about.contact.wechat": "微信公众号",
  "about.contact.qq": "QQ群",
  "about.contact.formTitle": "发送消息",
  "about.contact.formName": "您的称呼",
  "about.contact.formEmail": "电子邮箱",
  "about.contact.formSubject": "主题",
  "about.contact.formMessage": "留言内容",
  "about.contact.formSubmit": "发送消息",
  "about.contact.formSuccess": "消息已发送，我们会尽快回复您！",
  "about.contact.formError": "发送失败，请稍后重试。",
  "about.contact.charLimit": "最多500个字符",
}